import { SectionHeader } from "./SectionHeader";

const STEPS = [
  { n: "01", title: "Crear cuenta", desc: "Regístrate en menos de un minuto, sin tarjeta de crédito." },
  { n: "02", title: "Agregar productos", desc: "Carga tu inventario con precios, costos y existencias." },
  { n: "03", title: "Registrar ventas", desc: "Anota tus ventas de contado y a crédito al momento." },
  { n: "04", title: "Ver estadísticas", desc: "Consulta tus reportes de ingresos, gastos y ganancias." },
  { n: "05", title: "Dejar que la IA analice tu negocio", desc: "Recibe recomendaciones claras basadas en tus datos reales." },
];

export default function HowItWorks({ C }) {
  return (
    <section style={{ padding: "64px 20px", maxWidth: 720, margin: "0 auto" }}>
      <SectionHeader C={C} eyebrow="Cómo funciona" title="En cinco pasos, tu negocio bajo control" />
      <div style={{ marginTop: 40, display: "flex", flexDirection: "column" }}>
        {STEPS.map((s, i) => (
          <div key={s.n} style={{ display: "flex", gap: 18, animation: `slideIn 0.5s ease ${i * 0.06}s backwards` }}>
            <div style={{ display: "flex", flexDirection: "column", alignItems: "center" }}>
              <div style={{
                width: 40, height: 40, borderRadius: 12, flexShrink: 0,
                background: `${C.primary}18`, color: C.primary, border: `1px solid ${C.primary}35`,
                display: "flex", alignItems: "center", justifyContent: "center",
                fontWeight: 800, fontSize: 13,
              }}>{s.n}</div>
              {i < STEPS.length - 1 && <div style={{ width: 2, flex: 1, background: C.border, margin: "4px 0" }} />}
            </div>
            <div style={{ paddingBottom: 28 }}>
              <div style={{ color: C.text, fontWeight: 700, fontSize: 15.5, marginBottom: 4 }}>{s.title}</div>
              <div style={{ color: C.muted, fontSize: 13.5, lineHeight: 1.55 }}>{s.desc}</div>
            </div>
          </div>
        ))}
      </div>
    </section>
  );
}
